import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { StatusBadgeComponent } from './status-badge.component';

@NgModule({
    imports: [CommonModule, TwcModule, TranslateModule],
    exports: [StatusBadgeComponent],
    declarations: [StatusBadgeComponent],
})
export class StatusBadgeModule {}
